import { GroupType } from './conversationMembers.types';

export const GROUP_TYPE_ORDER: Record<GroupType, number> = {
  everyone: 3,
  group: 2,
  location: 0,
  position: 1,
};
